module.exports = __webpack_public_path__ + "img/is.9e18eabf.svg";